import React from 'react';
import PropTypes from 'prop-types';

import { Container } from '@material-ui/core';

import { Icon, Translate } from '@hydra/common/components';
import EditorFormRow from '@hydra/routes/pdf-editor/components/EditorFormRow/EditorFormRow';
import Editor from '@hydra/routes/pdf-editor/components/EditorFormRow/Editor';
import EditorInline from '@hydra/routes/pdf-editor/components/EditorFormRow/EditorInline';
import ImageUploader from '@hydra/routes/pdf-editor/components/ImageUploader';
import RichEditor from '@hydra/routes/pdf-editor/components/RichEditor/RichEditor';
import RichEditorPreview from '@hydra/routes/pdf-editor/components/RichEditor/RichEditorPreview';
import ImagePreview from '@hydra/routes/pdf-editor/components/ImagePreview';
import FormToggle from '@hydra/routes/pdf-editor/components/FormToggle';
import HelpText from '@hydra/routes/pdf-editor/components/HelpText';
import Header from '@hydra/routes/pdf-editor/components/Header';
import InfoLabel from '@hydra/routes/pdf-editor/components/InfoLabel';

export const TabIntroduction = ({
  template,
  editing,
  editingValue,
  setEditingValue,
  setEditingField,
  resetEditing,
  saveFormField,
  savePdfFile,
  headerLocked,
  featuresLocked
}) => {
  return (
    <>
      <Header title='pdf_editor_tab_introduction' hasLockedButton={headerLocked} />
      <Container>
        <EditorFormRow
          label={<Translate content='pdf_editor_add_introduction' />}
          locked={featuresLocked}
        >
          <EditorInline
            Component={FormToggle}
            field='introductionEnabled'
            value={template.introductionEnabled}
            otherFieldOpen={(editing !== null && editing !== 'introductionEnabled')}
            saveFormField={saveFormField}
            locked={featuresLocked}
          />
        </EditorFormRow>

        {
          template.introductionEnabled || headerLocked
            ? (
              <>
                <EditorFormRow
                  label={<Translate content='pdf_editor_logo' />}
                  help={<HelpText content='pdf_editor_option_help_logo' />}
                  locked={featuresLocked}
                >
                  <Editor
                    Component={ImageUploader}
                    field='logo'
                    fileUpload
                    preview={<ImagePreview field='logo' image={template.logo} />}
                    value={template.logo}
                    editingValue={editingValue}
                    editing={editing === 'logo'}
                    otherFieldOpen={(editing !== null && editing !== 'logo')}
                    setEditingValue={setEditingValue}
                    setEditingField={setEditingField}
                    resetEditing={resetEditing}
                    savePdfFile={savePdfFile}
                    locked={featuresLocked}
                  />
                </EditorFormRow>

                <EditorFormRow
                  label={<Translate content='pdf_editor_display_score' />}
                  help={<HelpText content='pdf_editor_option_help_display_score' />}
                  locked={featuresLocked}
                >
                  <EditorInline
                    Component={FormToggle}
                    field='displayScore'
                    value={template.displayScore}
                    otherFieldOpen={(editing !== null && editing !== 'displayScore')}
                    saveFormField={saveFormField}
                    locked={featuresLocked}
                  />
                </EditorFormRow>

                <EditorFormRow
                  label={<Translate content='pdf_editor_intro_text' />}
                  help={<HelpText content='pdf_editor_option_help_intro_text' />}
                  locked={featuresLocked}
                >
                  <Editor
                    Component={RichEditor}
                    field='coverPage'
                    defaultContent='pdf_default_branded_description'
                    preview={
                      <RichEditorPreview
                        content={template.coverPage}
                        defaultContent={<Translate content='pdf_default_branded_description' />}
                      />
                    }
                    value={template.coverPage}
                    editingValue={editingValue}
                    editing={editing === 'coverPage'}
                    otherFieldOpen={(editing !== null && editing !== 'coverPage')}
                    setEditingValue={setEditingValue}
                    setEditingField={setEditingField}
                    resetEditing={resetEditing}
                    saveFormField={saveFormField}
                    locked={featuresLocked}
                  />
                </EditorFormRow>
              </>
              )
            : (
              <EditorFormRow infoLabel>
                <InfoLabel style='default'>
                  <Icon type='information' style={{ marginRight: 8 }} />
                  <Translate content='pdf_editor_introduction_info' />
                </InfoLabel>
              </EditorFormRow>
              )
        }
      </Container>
    </>
  );
};

TabIntroduction.propTypes = {
  template: PropTypes.shape({
    name: PropTypes.string
  })
};

export default React.memo(TabIntroduction);
